module.exports = __webpack_public_path__ + "static/media/uniflex.bd644eb4.png";